export const PERMISSIONS = {
  ENTITY_READ: "entity:read",
  ENTITY_CREATE: "entity:create",
  ENTITY_UPDATE: "entity:update",
  ENTITY_DEACTIVATE: "entity:deactivate",

  CLIENT_READ: "client:read",
  CLIENT_CREATE: "client:create",
  CLIENT_UPDATE: "client:update",
  CLIENT_DEACTIVATE: "client:deactivate",

  USER_READ: "user:read",
  USER_CREATE: "user:create",
  USER_UPDATE: "user:update",
  USER_DEACTIVATE: "user:deactivate",

  CUSTOMER_READ: "customer:read",
  CUSTOMER_ONBOARD: "customer:onboard",
  CUSTOMER_PROFILE_UPDATE: "customer:profile_update",
  CUSTOMER_DEACTIVATE: "customer:deactivate",
  CUSTOMER_MANAGE_DEVICES: "customer:manage_devices",

  DEVICE_READ: "device:read",
  DEVICE_READ_INVENTORY: "device:read_inventory",
  DEVICE_CREATE: "device:create",
  DEVICE_UPDATE: "device:update",
  DEVICE_DELETE: "device:delete",
  DEVICE_SETTINGS_UPDATE: "device:settings_update",
  DEVICE_SETTINGS_VIEW: "device:settings_view",
  DEVICE_MANAGE_SIM: "device:manage_sim",

  ALERTS_VIEW: "alerts:read",
  ALERTS_EXPORT: "alerts:export",

  ORDER_READ: "order:read",
  ORDER_CREATE: "order:create",

  PAYMENT_MANAGE_CLIENT: "payment:manage_client",
  PAYMENT_READ: "payment:read",

  RECEIPT_READ: "receipt:read",
  RECEIPT_DOWNLOAD: "receipt:download",

  RBAC_READ: "rbac:read",
  RBAC_MANAGE: "rbac:manage",
  REPORT_CUSTOMER_ENROLMENT_READ: "report:customer_enrolment:read",
  REPORT_CUSTOMER_ENROLMENT_EXPORT: "report:customer_enrolment:export",
};